import ClearIcon from '@mui/icons-material/Clear'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Modal from '@mui/material/Modal'
import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import 'react-phone-number-input/style.css'
import ApiService from '../ApiService'
import { USER_URL } from '../constants'
import '../scss/login.scss'
import UserTelephone from './user_telephone'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: '-3px -3px 7px #97949473, 2px 2px 7px rgb(137, 138, 138)',
  pt: 2,
  px: 4,
  pb: 3
}

const PopUpUser = ({
  showToast,
  handleClose,
  handleOpen,
  open,
  userToEdit,
  setValue,
  reset,
  resetField,
  register,
  handleSubmit,
  errors,
  control,
  setUpdateSerial
}) => {
  const [id, setId] = useState('')
  const [password, setEditPassword] = useState('')
  const [twilioNumber, setTwilioNumber] = useState('')

  const token = localStorage.getItem('token')

  useEffect(() => {
    if (userToEdit) {
      setValue('firstname', userToEdit.firstName)
      setValue('lastname', userToEdit.lastName)
      setValue('email', userToEdit.email)
      setValue('telephone', userToEdit.telephone)
      setTwilioNumber(userToEdit.telephone)
      setId(userToEdit.id)
    } else {
      reset()
      resetField()
    }
  }, [userToEdit])

  const handleEditPassword = (e) => {
    setEditPassword(e.target.value)
  }

  const handleSubmitData = async (data) => {
    try {
      const { success, error } = await addOrUpdate(data)
      if (success) {
        if (userToEdit != null) {
          reset()
          resetField()
          handleClose(userToEdit?.id, null)
        } else {
          handleClose(0, null)
        }
        if (userToEdit) {
          showToast('User Updated', 'success') // Call the showToast method with two arguments
          reset()
        } else {
          reset()
          showToast('User Added', 'success') // Call the showToast method with two arguments
        }
        // navigate("/home"); // Redirect to the home page
      } else {
        reset()
        resetField()
        handleClose(0, null)
        showToast(error || 'Failed to add user', 'error') // Call the showToast method with two arguments
      }
    } catch (error) {
      console.error('Error occurred while adding user:', error)
    }
  }

  const addOrUpdate = async (data) => {
    const user = {
      id,
      firstName: data.firstname,
      lastName: data.lastname,
      email: data.email,
      telephone: twilioNumber || '',
      password
    }

    try {
      let requestType = 'POST'
      if (userToEdit) {
        requestType = 'PUT'
      }
      const { success, error } = await ApiService.makeApiCall(
        USER_URL,
        requestType,
        user,
        token
      )
      if (success) {
        return { success: true }
      } else {
        return { success: false, error }
      }
    } catch (e) {
      showToast(`Failed to add/update User ${e}`, 'error')
      return { success: false, error: e }
    }
  }

  return (
    <div>
      <Modal
        open={open}
        userToEdit={userToEdit}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: 400,
            overflow: 'hidden',
            borderRadius: '4px'
          }}
        >
          <IconButton
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1
            }}
            onClick={handleClose}
          >
            <ClearIcon />
          </IconButton>
          <form onSubmit={handleSubmit(handleSubmitData)}>
            <h1
              style={{
                marginBottom: '0.5rem',
                fontSize: '1.5rem',
                fontWeight: '600'
              }}
              className="delete-modal-heading"
            >
              {userToEdit === null ? 'Add User' : 'Edit User'}
            </h1>
            <hr style={{ width: '100%', borderTop: '1px solid #E5E5E5' }} />

            {/* First Name */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> First Name </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="firstname"
              name="firstname"
              // placeholder="Enter your first name"
              className="editAddUserFieldsAlign global-font mt-0"
              {...register('firstname', {
                required: {
                  value: true,
                  message: 'Firstname is required!'
                },
                pattern: {
                  value: /^[A-Z]+$/i,
                  message: 'Only alphabets allowed!'
                }
              })}
              style={{ marginBottom: '12px' }}
            />
            {errors.firstname && (
              <p className="ms-4 mb-1" style={{ fontSize: 14, color: 'red' }}>
                {errors.firstname.message}
              </p>
            )}

            {/* Last Name */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Last Name </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              id="lastname"
              name="lastname"
              // placeholder="Enter your last name"
              className="editAddUserFieldsAlign global-font mt-0"
              {...register('lastname', {
                required: {
                  value: true,
                  message: 'Lastname is required!'
                },
                pattern: {
                  value: /^[A-Z]+$/i,
                  message: 'Only alphabets allowed!'
                }
              })}
              style={{ marginBottom: '12px' }}
            />
            {errors.lastname && (
              <p className="ms-4 mb-1" style={{ fontSize: 14, color: 'red' }}>
                {errors.lastname.message}
              </p>
            )}

            {/* Email */}
            <label className="form-label" style={{ marginBottom: '5px' }}>
              <span className="generate-modal-sub-head"> Email </span>
              <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              // placeholder="Enter your email"
              className="editAddUserFieldsAlign global-font mt-0"
              {...register('email', {
                required: {
                  value: true,
                  message: 'Email is required!'
                },
                pattern: {
                  value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                  message: 'Please correct email format!'
                }
              })}
              style={{ marginBottom: '12px' }}
            />
            {errors.email && (
              <p className="ms-4 mb-1" style={{ fontSize: 14, color: 'red' }}>
                {errors.email.message}
              </p>
            )}

            {/* Phone Number */}
            <label className="form-label" style={{ marginBottom: '0px' }}>
              <span className="generate-modal-sub-head mb-0">Telephone No.</span>
              {/* <span className="text-danger">*</span> */}
            </label>
            <UserTelephone
            userToEdit={userToEdit}
            twilioNumber={twilioNumber}
            setTwilioNumber={setTwilioNumber}
              name="telephone"
              id="telephone"
              control={control}
              international
              countryCallingCodeEditable={false}
              defaultCountry="US"
              limitMaxLength={10}
              rules={{
                required: {
                  value: true,
                  message: 'Telephone is required!'
                }
              }}
            />

            {errors.telephone && (
              <p className="ms-4 mb-1" style={{ fontSize: 14, color: 'red' }}>
                {errors.telephone.message}
              </p>
            )}
            {userToEdit && (
              <input
                type="password"
                id="password"
                placeholder="password (empty if unchanged)"
                className="editAddUserFieldsAlign "
                value={password}
                onChange={handleEditPassword}
              />
            )}
            <Button
              style={{
                backgroundColor: '#00C72E',
                color: '#ffff',
                border: 'none',
                width: '97px',
                height: '38px',
                borderRadius: '4px !important',
                float: 'right',
                marginTop: '5px'
              }}
              className="global-font rounded-2 py-2 fw-medium ms-0 mb-1 me-0"
              type="submit"
            >
              {userToEdit === null ? 'Add User' : 'Edit User'}
            </Button>
            {/* {error && <p className="error">{error}</p>} */}
          </form>
        </Box>
      </Modal>
    </div>
  )
}

export default PopUpUser
